import React, { useState } from "react";

const FastApiToolModal = ({ onClose }) => {
  const [lineFile, setLineFile] = useState(null);
  const [pointFile, setPointFile] = useState(null);
  const [bufferDistance, setBufferDistance] = useState("25");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!lineFile || !pointFile) {
      setErrorMessage("Please select both the Line and Point layers (.zip, .kml, or .kmz).");
      return;
    }

    setLoading(true);
    setErrorMessage("");

    // Package data into standard HTML Multipart Form Data for FastAPI
    const formData = new FormData();
    
    // MATCHED TO UPDATED BACKEND: Using the generalized file keys instead of zip-specific keys
    formData.append("line_file", lineFile);
    formData.append("point_file", pointFile);
    formData.append("buffer_distance", parseFloat(bufferDistance));

    try {
      // Combined your Render domain with the proper backend execution route
      const response = await fetch("https://fastapi-h77c.onrender.com/api/process-gis", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        const descriptiveError = typeof errorData.detail === "string" 
          ? errorData.detail 
          : errorData.detail?.[0]?.msg || "Failed to process geospatial data.";
        throw new Error(descriptiveError);
      }

      // Handle binary stream blob coming back from FastAPI (The generated Excel Report)
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", "GIS_Vertex_Report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl); // Memory optimization cleanup
      
      onClose(); // Auto close modal on successful generation
    } catch (err) {
      setErrorMessage(err.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.header}>
          <h3 style={{ margin: 0 }}>⚡ Transmission GIS Vertex Tool</h3>
          <button onClick={onClose} style={styles.closeBtn}>&times;</button>
        </div>

        <form onSubmit={handleSubmit} style={styles.form}>
          {errorMessage && <div style={styles.errorBanner}>{errorMessage}</div>}

          <div style={styles.inputGroup}>
            <label style={styles.label}>Select Line Layer:</label>
            <input 
              type="file" 
              accept=".zip,.kml,.kmz" 
              onChange={(e) => setLineFile(e.target.files[0])} 
              style={styles.fileInput}
            />
            <small style={styles.helpText}>Accepts zipped Shapefile (.zip) or KML/KMZ files</small>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Select Point Layer:</label>
            <input 
              type="file" 
              accept=".zip,.kml,.kmz" 
              onChange={(e) => setPointFile(e.target.files[0])} 
              style={styles.fileInput}
            />
            <small style={styles.helpText}>Accepts zipped Shapefile (.zip) or KML/KMZ files</small>
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Buffer Distance (meters):</label>
            <input 
              type="number" 
              value={bufferDistance} 
              onChange={(e) => setBufferDistance(e.target.value)} 
              style={styles.textInput}
              min="1"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading} 
            style={{ ...styles.submitBtn, backgroundColor: loading ? "#cccccc" : "#107c41" }}
          >
            {loading ? "PROCESSING GEOSPATIAL LAYERS..." : "GENERATE EXCEL REPORT"}
          </button>
        </form>
      </div>
    </div>
  );
};

// Clean scoped UI CSS-in-JS configurations matching your previous modal look
const styles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex", justifyContent: "center", alignItems: "center",
    zIndex: 1000
  },
  modal: {
    backgroundColor: "#ffffff",
    borderRadius: "8px",
    width: "100%", maxWidth: "500px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
    overflow: "hidden"
  },
  header: {
    padding: "20px", borderBottom: "1px solid #eeeeee",
    display: "flex", justifyContent: "space-between", alignItems: "center"
  },
  closeBtn: {
    background: "none", border: "none", fontSize: "24px", cursor: "pointer", color: "#999"
  },
  form: { padding: "20px" },
  inputGroup: { marginBottom: "20px" },
  label: { display: "block", marginBottom: "4px", fontWeight: "bold", fontSize: "14px", color: "#333" },
  helpText: { display: "block", fontSize: "11px", color: "#666", marginTop: "2px" },
  fileInput: { width: "100%", padding: "4px 0" },
  textInput: { width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc", boxSizing: "border-box" },
  errorBanner: { padding: "10px", backgroundColor: "#fde8e8", color: "#e53e3e", borderRadius: "4px", marginBottom: "15px", fontSize: "14px" },
  submitBtn: {
    width: "100%", color: "#ffffff", border: "none", padding: "12px",
    borderRadius: "4px", fontSize: "15px", fontWeight: "bold", cursor: "pointer", transition: "background-color 0.2s"
  }
};

export default FastApiToolModal;